import CorneredBox from "../CorneredBox";
import { Container } from "react-bootstrap";
import Breadcrumb, { BreadcrumbItem } from "../Breadcrumb";
import HeadingText1 from "../HeadingText1";
import HeadingText2 from "../../styled/HeadingText2";
import { FC, useEffect, useState } from "react";
import Text from "../../styled/Text";
import { ButtonStyled } from "../Button.styled";
import { useRouter } from "next/router";
import Head from "next/head";
import { titleCase } from "../../utils/titleCase";
import { allConcernedAreas } from "../../constants/concernedAreasForLegalConsultation";
import { withRouter } from "next/router";
import { City } from "../../all-city";
import { random } from "lodash";
// @ts-ignore
import StarRatingComponent from "react-rating-stars-component";
import useResponsiveDevice from "../../components/useResponsiveDevice";
import CityLawyerPopUp from "../CityLawyerLeadPopUp";

interface Props {
  concernedArea?: string;
  city: string;
  showMore?: boolean;
  handleClickShowMore: () => void;
  urlYoutube: string;
  city_data: any;
  lawyersProfile: any;
  finalConcernedAreaData: any;
}

function getSchema(o: any) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(o) }}
    />
  );
}

const CityLawyerComponent: FC<{ title: string; content: string }> = ({
  title,
  content,
}) => {
  return (
    <>
      <HeadingText2
        fontSize="lg"
        fontFamily="montserrat"
        weight="bold"
        className="mb-3 mt-4"
      >
        {title}
      </HeadingText2>
      <Text
        as="div"
        fontSize={"mdl"}
        weight="400"
        color="secondary2"
        className="mb-4"
        // style={{ whiteSpace: "pre-line" }}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </>
  );
};

const CityLawyerHeader: FC<Props> = ({
  concernedArea,
  city,
  showMore,
  handleClickShowMore,
  urlYoutube,
  city_data,
  lawyersProfile,
  finalConcernedAreaData,
}) => {
  const { isMobile } = useResponsiveDevice();
  const [show, setShow] = useState(false);
  const handleClosePop = () => {
    setShow(false);
  };
  const concernedAreas = allConcernedAreas
    .filter(
      (concernedArea, index) =>
        concernedArea !== "Other Legal Problem" &&
        concernedArea !== "Other Property Issues" &&
        concernedArea !== "Any other Business Legal matter" &&
        allConcernedAreas.indexOf(concernedArea) === index
    )
    .sort();

  let chunk,
    dividedConcernedArea = [];
  while (concernedAreas.length > 0) {
    chunk = concernedAreas.splice(0, 7);
    dividedConcernedArea.push(chunk);
  }
  const router = useRouter();
  const allcities = City.getCitiesOfCountry("IN");

  let indexOfCurrentCity: any;
  allcities?.map((citi: any, index: any) => {
    if (city === citi.name) {
      indexOfCurrentCity = index;
    }
  });
  const nextCities = allcities.slice(
    indexOfCurrentCity + 1,
    indexOfCurrentCity + 20
  );

  const remappedConcernedArea = `${
    concernedArea == "Gst"
      ? "GST"
      : concernedArea == "Nclt Matter"
        ? "NCLT"
        : concernedArea == "Rera Act"
          ? "RERA"
          : concernedArea == "Trademark And Copyrights"
            ? "Trademark and Copyrights"
            : concernedArea == "Labour And Employment"
              ? "Labour and Employment"
              : concernedArea == "Investment And Fundraise"
                ? "Investment and Fundraise"
                : concernedArea == "Alimony And Maintenance"
                  ? "Alimony and Maintenance"
                  : concernedArea
  }`;

  const breadcrumbItems: BreadcrumbItem[] = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Find Lawyers",
      link: "/find-all-lawyers-in-cities",
    },
    {
      label: `Find ${remappedConcernedArea} Lawyers`,
      link: `/find-all-lawyers-in-cities/${concernedArea
        ?.toLowerCase()
        .replace(/ /g, "-")}`,
    },
    {
      label: `Find ${remappedConcernedArea} Lawyers in ${city}`,
      link: null,
    },
  ];

  const breadcrumbWOCAItems: BreadcrumbItem[] = [
    {
      label: "Home",
      link: "/",
    },
    {
      label: "Find Lawyers",
      link: "/find-all-lawyers-in-cities",
    },
    {
      label: `Lawyers in ${city}`,
      link: null,
    },
  ];

  const schemaObject: any = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: !concernedArea
      ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
      : `${concernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`,
    image:
      "https://cms.ezylegal.in/wp-content/uploads/2021/06/cases_black_24dp.svg",
    description: !concernedArea
      ? `Hire experienced lawyer in ${city} to get the best and right legal advice instantly also consult experienced and verified legal advisors in ${city}.`
      : `ezyLegal helps you find ${concernedArea} legal advisor in your location basis your need like matrimonial & property disputes, divorce, real estate, employment & criminal law matters`,
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "83",
      worstRating: "1",
      bestRating: "5",
    },
  };
  const city_content = city_data?.content
    ?.replace(/&lt;Akhnur&gt;/g, city)
    .replace(/&lt;Akhnur>/g, city);
  const city_Title = city_data?.cities?.fold2Title?.replace(/<Akhnur>/g, city);
  const secondContent = city_data?.cities?.secondContent?.replace(
    /&lt;Akhnur&gt;/g,
    city
  );
  const concern_content = finalConcernedAreaData?.content
    ?.replace(/&lt;Akhnur&gt;/g, city)
    .replace(/&lt;Akhnur>/g, city)
    .replace(/<Delhi>/g, city)
    .replace(/&lt;Delhi&gt;/g, city)
    .replace(/&lt;Delhi>/g, city);
  const concern_Title = finalConcernedAreaData?.cities?.fold2Title
    ?.replace(/<Akhnur>/g, city)
    .replace(/<Delhi>/g, city)
    .replace(/&lt;Delhi&gt;/g, city)
    .replace(/&lt;Delhi>/g, city);
  const secondContentConcernArea = finalConcernedAreaData?.cities?.secondContent
    ?.replace(/&lt;Akhnur&gt;/g, city)
    .replace(/<Delhi>/g, city)
    .replace(/&lt;Delhi&gt;/g, city)
    .replace(/&lt;Delhi>/g, city);

  const concernedAreaList = finalConcernedAreaData?.cities?.concerned
    ? finalConcernedAreaData?.cities?.concerned
    : city_data?.cities?.concerned;

  const seo_city_discription = city_data?.seo?.description
    .replace(/&lt;Akhnur&gt;/g, city)
    .replace(/&lt;Akhnur>/g, city)
    .replace(/<Akhnur>/g, city);
  const seo_concernedArea_discription = finalConcernedAreaData?.seo?.description
    .replace(/&lt;Akhnur&gt;/g, city)
    .replace(/&lt;Akhnur>/g, city)
    .replace(/<Akhnur>/g, city);
  return (
    <>
      <Head>
        {getSchema(schemaObject)}
        <link
          rel="canonical"
          href={`https://www.ezylegal.in/city-lawyers${router?.asPath}`}
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:url"
          content={`https://www.ezylegal.in/city-lawyers${router?.asPath}`}
        />
        <meta
          property="og:image"
          content="https://ezylegal.in/images/EzyLegal_final_logo-Kit-08_128x128.jpg"
        />
        <meta
          property="og:title"
          content={
            !concernedArea
              ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
              : `${remappedConcernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`
          }
        />
        <meta
          property="og:description"
          content={
            !concernedArea
              ? `${seo_city_discription}`
              : `${seo_concernedArea_discription}`
          }
        />
        <meta
          property="title"
          content={
            !concernedArea
              ? `Consult Top 10 Lawyers in ${city} | Talk to Lawyers in ${city}`
              : `${remappedConcernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`
          }
        />
        <meta
          name="description"
          content={
            !concernedArea
              ? `${seo_city_discription}`
              : `${seo_concernedArea_discription}`
          }
        />
        <meta name="robots" content="index, follow" />
        <meta name="copyright" content="ezyLegal" />
        <meta name="reply-to" content={"contact@ezylegal.in"} />
        <title>
          {!concernedArea
            ? `Lawyers and Legal Advisors in ${city} | ezyLegal`
            : `${remappedConcernedArea} Lawyers and Legal Advisors in ${city} | ezyLegal`}
        </title>
      </Head>
      <CorneredBox
        // marginTop="-25px"
        paddingTop="20px"
        zIndex={15}
        position="relative"
        paddingBottom="30px"
        bgColor="lightSkyBlue"
      >
        <Container className="pt-1">
          {/* <Breadcrumb
            items={concernedArea ? breadcrumbItems : breadcrumbWOCAItems}
          /> */}
          {/* {!concernedArea && ( */}
          <>
            <HeadingText2
              fontSize="xxl"
              fontFamily="montserrat"
              weight="bold"
              className="mb-4"
            >
              {concern_Title != "" && concern_Title != undefined
                ? concern_Title
                : city_Title}
            </HeadingText2>
            <Text
              as="div"
              fontSize={"mdl"}
              weight="400"
              color="secondary2"
              // style={{ whiteSpace: "pre-line" }}
              dangerouslySetInnerHTML={{
                __html:
                  concern_content != "" && concern_content != undefined
                    ? concern_content
                    : city_content,
              }}
            />
            <div className="container justify-content-center d-flex mt-4 mb-4">
              <div className="row">
                <div
                  className="btn-main"
                  style={{ display: "flex", gap: "4px" }}
                >
                  {concernedAreaList?.map((val: any, index: any) => {
                    let concernedArea_text = val.button.text;
                    if (val.button.text == "Employment & Labour") {
                      concernedArea_text = "Labour & Employment";
                    }
                    let url = `find-${concernedArea_text
                      .toLowerCase()
                      .replace(/ /g, "-")
                      .replace(/&/g, "and")}-lawyers-in-${city
                      .toLowerCase()
                      .replace(/ /g, "-")}`;
                    if (index < 5) {
                      return (
                        <a
                          href={url}
                          className={isMobile ? "btn-header" : ""}
                          style={{ textAlign: "center", padding: "4px 6px" }}
                        >
                          <button className="btn-header">
                            {val.button.text}
                          </button>
                        </a>
                      );
                    }
                  })}
                  <a
                    href="#CONCERNED_AREA"
                    className={isMobile ? "btn-header" : ""}
                    style={{ textAlign: "center", padding: "4px 6px" }}
                    onClick={() => {
                      handleClickShowMore();
                    }}
                  >
                    <button className="btn-header">Others</button>
                  </a>
                </div>
              </div>
            </div>
            {lawyersProfile?.user?.map((val: any) => {
              var cureentYear = new Date();
              const experience = val?.professional_details[0]?.passing_year
                ? cureentYear.getFullYear() -
                  val.professional_details[0].passing_year
                : "15";
              const rating = random(4, 5);
              return (
                <div
                  className="lawyer-item border-box"
                  style={{ border: "1px solid #feeb64" }}
                >
                  <div className="row">
                    <div className="col-sm-7 col-xs-12">
                      <div className="media">
                        <div className="pull-left">
                          <a>
                            <img
                              className="media-object img-responsive"
                              style={{
                                borderRadius: "5px",
                                overflow: "hidden",
                                boxShadow: "1px 1px 1px rgba(0,0,0,0.3)",
                                width: "86px",
                              }}
                              src={
                                val.gender == "MALE"
                                  ? "/city-lawyers/icons/lawyer-icon.png"
                                  : "/city-lawyers/icons/lawyer-icon-f.png"
                              }
                            />
                          </a>
                        </div>
                        <div className="media-body">
                          <div className="small-info">
                            <a
                              style={{
                                filter: "blur(4px)",
                              }}
                            >
                              <h2
                                className="media-heading"
                                style={{ lineHeight: "1.1" }}
                              >
                                {val.name}
                              </h2>
                            </a>
                            <div className="location">
                              <img
                                src="https://lawrato.com/assets/img/sprite/icon/map-marker-icon.png"
                                alt="LawRato"
                              />
                              <span>
                                {val.city ? val.city : city}, {val.state}
                              </span>{" "}
                            </div>
                            <div className="experience">
                              <img
                                src="https://lawrato.com/assets/img/sprite/icon/suitcase-icon.png"
                                alt="LawRato"
                              />
                              <span>&nbsp;{experience} years Experience</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-5 alpha hidden-xs">
                      <div
                        className="rating"
                        style={{
                          display: !isMobile ? "flex" : "",
                          gap: "9px",
                          filter: "blur(4px)",
                        }}
                      >
                        <span className="star-rating">
                          <StarRatingComponent
                            size={14}
                            count={5}
                            value={rating}
                            isHalf={true}
                            edit={false}
                            activeColor="#ffd700"
                          />
                          {/* <img style={{ marginRight: '5px', width: '15px', height: '15px' }} src="https://lawrato.com/assets/img/sprite/icon/rating-star-full-icon.png" alt="LawRato" /><img style={{ marginRight: '5px', width: '15px', height: '15px' }} src="https://lawrato.com/assets/img/sprite/icon/rating-star-full-icon.png" alt="LawRato" /><img style={{ marginRight: '5px', width: '15px', height: '15px' }} src="https://lawrato.com/assets/img/sprite/icon/rating-star-full-icon.png" alt="LawRato" /><img style={{ marginRight: '5px', width: '15px', height: '15px' }} src="https://lawrato.com/assets/img/sprite/icon/rating-star-full-icon.png" alt="LawRato" /><img style={{ marginRight: '5px', width: '15px', height: '15px' }} src="https://lawrato.com/assets/img/sprite/icon/rating-star-half-icon.png" alt="LawRato" />
                            </span> */}
                        </span>
                        <span className="score">
                          {rating} | 100+ user ratings
                        </span>
                      </div>
                      <div className="area-skill">
                        <strong>Practice Area </strong>
                        <div>
                          {val?.professional_details[0]?.specialization?.map(
                            (val: any, index: any) => {
                              if (index < 4) {
                                return (
                                  <Text
                                    inline
                                    color="black"
                                    className="mb-0"
                                    fontSize={"md"}
                                    weight="400"
                                  >
                                    {val},&nbsp;
                                  </Text>
                                  // <a></a>
                                );
                              }
                            }
                          )}
                          <Text
                            inline
                            color="black"
                            className="mb-0"
                            fontSize={"md"}
                            weight="400"
                          >
                            {val.professional_details[0]?.specialization
                              ?.length > 4
                              ? `+${
                                  val.professional_details[0]?.specialization
                                    ?.length - 4
                                } more`
                              : ""}
                          </Text>
                        </div>
                      </div>
                      <div className="cta margin-small-top">
                        <ButtonStyled
                          backgroundColor="#396AE8"
                          color="#fff"
                          className="d-flex align-items-center justify-content-center mt-3"
                          onClick={() => setShow(true)}
                        >
                          <Text className="mb-0">CONTACT NOW</Text>
                        </ButtonStyled>
                        {/* <a href="https://lawrato.com/advocate-rajeev-nigam" className="button  button-primary button-small">CONTACT NOW</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </>
          {/* )} */}
          {concernedArea !== "" && urlYoutube && (
            <iframe
              width="100%"
              allowFullScreen
              style={{ aspectRatio: "16/9" }}
              src={`${urlYoutube}?controls=1&showinfo=1&rel=0&iv_load_policy=3`}
              title={`YouTube video ${concernedArea}`}
            />
          )}
          {showMore && (
            <>
              {/* {!concernedArea && ( */}
              <Text
                as="div"
                fontSize={"mdl"}
                weight="400"
                color="secondary2"
                // style={{ whiteSpace: "pre-line" }}
                dangerouslySetInnerHTML={{
                  __html:
                    secondContentConcernArea != "" &&
                    secondContentConcernArea != undefined
                      ? secondContentConcernArea
                      : secondContent,
                }}
              />
              {/* )} */}
            </>
          )}
          {showMore && (
            <div id="CONCERNED_AREA">
              <HeadingText2
                fontSize="lg"
                fontFamily="montserrat"
                weight="bold"
                className="mb-3"
              >
                Find Lawyers by Practice Area in {city}
              </HeadingText2>
              <div className="row">
                {dividedConcernedArea.map((CONCERNED_AREA: any) => {
                  return (
                    <div className="col-md-4">
                      {CONCERNED_AREA.map((val: any) => {
                        return (
                          <ul>
                            <li>
                              <a
                                className="sitmap-link"
                                href={`https://www.ezylegal.in/city-lawyers/find-${val
                                  .toLowerCase()
                                  .replace(/ /g, "-")}-lawyers-in-${city
                                  .toLowerCase()
                                  .replace(/ /g, "-")}`}
                              >
                                {val}
                              </a>
                            </li>
                          </ul>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
              {/* <div className="row">
                {concernedAreas &&
                  concernedAreas?.map((CONCERNED_AREA: any) => {
                    return (
                      <div>
                        <a
                          className="sitmap-link"
                          href={`https://www.ezylegal.in/city-lawyers/find-${CONCERNED_AREA.toLowerCase().replace(
                            / /g,
                            "-"
                          )}-lawyers-in-${city.toLowerCase().replace(/ /g, "-")}`}
                        >
                          {`${CONCERNED_AREA}`}
                        </a>
                      </div>
                    );
                  })}
              </div> */}
            </div>
          )}
          {/* {showMore && (
            <div className="mt-4">
              <HeadingText2
                fontSize="lg"
                fontFamily="montserrat"
                weight="bold"
                className="mb-3"
              >
                Other Cities searched for
              </HeadingText2>
              <div>
                {nextCities &&
                  nextCities?.map((citi: any, index: any) => {
                    return (
                      <a
                        className="sitmap-link"
                        href={`https://www.ezylegal.in/city-lawyers/find-lawyers-in-${citi.name
                          .toLowerCase()
                          .replace(/ /g, "-")}`}
                      >
                        {`Lawyers and Legal Advisors in ${citi.name}`}
                      </a>
                    );
                  })}
              </div>
            </div>
          )} */}
          <ButtonStyled
            backgroundColor="#396AE8"
            color="#fff"
            className="d-flex align-items-center justify-content-center mt-3"
            onClick={handleClickShowMore}
          >
            <Text className="mb-0">{showMore ? "Read Less" : "Read More"}</Text>
            <div
              className="d-flex align-items-center justify-content-center ml-2"
              style={{
                transform: showMore ? "rotate(-90deg)" : "rotate(90deg)",
              }}
            >
              <img
                src="/city-lawyers/icons/caretr.svg"
                alt="see-more-less-button"
                height={10}
                width={10}
              />
            </div>
          </ButtonStyled>
        </Container>
        <CityLawyerPopUp
          show={show}
          onHide={handleClosePop}
          size="lg"
          type={"author"}
        />
      </CorneredBox>
    </>
  );
};

export default CityLawyerHeader;
